
import { createSelector, Selector } from '@reduxjs/toolkit';

import { RootState } from '../../rootReducer';

import { selectActiveCreditsPoolsIds, selectArchivedCreditsPoolsIds, selectMapOfAllCreditsPools, selectCurrentViewActiveVsArchived } from '../../credits/creditsPools/selectors';
import { selectors as userSelectors } from '../../users/list';
import { ICreditsPoolOverview } from '../../../components/credits/views/CreditsPoolsDashboard/CreditsPoolOverview';
import { IUser } from '../../users/user';
import { CreditsPoolView } from '../../credits/creditsPools/creditsPools.slice';

const appendUserDataAndMapFields = (
  creditsPoolsIds: string[],
  map: RootState['credits']['creditsPools']['map'],
  userListInStore: IUser[] // TODO: userListInStore has impact on performance here, as search is done by iteration
): ICreditsPoolOverview[] => {

  const result: ICreditsPoolOverview[] = [];

  creditsPoolsIds.forEach((creditsPoolId) => {
    const creditsPoolData = map[creditsPoolId];
    const users: Array<ICreditsPoolOverview['users'][0]> = [];
    creditsPoolData.members.forEach((userId) => {
      const userInStore = userListInStore.find((user) => user.id === userId);
      if(userInStore) {
        users.push({
          firstName: userInStore.firstName,
          lastName: userInStore.lastName,
          email: userInStore.email
        });
      }
    });

    result.push({
      id: creditsPoolData._id,
      name: creditsPoolData.name,
      credits: creditsPoolData.creditsAvailable,
      pending: creditsPoolData.creditsPending,
      finalized: creditsPoolData.creditsFinalized,
      thresholdWarningMessage: creditsPoolData.thresholdWarningMessage,
      users
    });
  });

  return result;
};

export const selectActiveCreditsPoolsWithUsers: Selector<RootState, ICreditsPoolOverview[]> = createSelector(
  [selectActiveCreditsPoolsIds, selectMapOfAllCreditsPools, userSelectors.getList],
  appendUserDataAndMapFields
);

export const selectArchivedCreditsPoolsWithUsers: Selector<RootState, ICreditsPoolOverview[]> = createSelector(
  [selectArchivedCreditsPoolsIds, selectMapOfAllCreditsPools, userSelectors.getList],
  appendUserDataAndMapFields
);

export const getCreditsPoolsSelector: Selector<RootState, Selector<RootState, ICreditsPoolOverview[]>> = createSelector(
  [selectCurrentViewActiveVsArchived, selectActiveCreditsPoolsWithUsers, selectArchivedCreditsPoolsWithUsers],
  (view: ReturnType<typeof selectCurrentViewActiveVsArchived>) => {
    if(view === CreditsPoolView.Active) {
      return selectActiveCreditsPoolsWithUsers;
    }
    return selectArchivedCreditsPoolsWithUsers;
  }
);
